"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Output_id, _Output_inputValidator, _Output_logger, _Output_name, _Output_sessionEngine, _Output_uuidGenerator, _Output_bbmax, _Output_bbmin, _Output_chunks, _Output_content, _Output_delay, _Output_dependency, _Output_displayname, _Output_hidden, _Output_material, _Output_msg, _Output_order, _Output_status_collect, _Output_status_computation, _Output_tooltip, _Output_uid, _Output_updateCallback, _Output_version;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Output = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
class Output {
    // #endregion Properties (23)
    // #region Constructors (1)
    constructor(outputDef, sessionEngine) {
        // #region Properties (23)
        _Output_id.set(this, void 0);
        _Output_inputValidator.set(this, viewer_shared_services_1.InputValidator.instance);
        _Output_logger.set(this, viewer_shared_services_1.Logger.instance);
        _Output_name.set(this, void 0);
        _Output_sessionEngine.set(this, void 0);
        _Output_uuidGenerator.set(this, viewer_shared_services_1.UuidGenerator.instance);
        _Output_bbmax.set(this, void 0);
        _Output_bbmin.set(this, void 0);
        _Output_chunks.set(this, void 0);
        _Output_content.set(this, void 0);
        _Output_delay.set(this, void 0);
        _Output_dependency.set(this, void 0);
        _Output_displayname.set(this, void 0);
        _Output_hidden.set(this, false);
        _Output_material.set(this, void 0);
        _Output_msg.set(this, void 0);
        _Output_order.set(this, void 0);
        _Output_status_collect.set(this, void 0);
        _Output_status_computation.set(this, void 0);
        _Output_tooltip.set(this, void 0);
        _Output_uid.set(this, void 0);
        _Output_updateCallback.set(this, null);
        _Output_version.set(this, void 0);
        __classPrivateFieldSet(this, _Output_sessionEngine, sessionEngine, "f");
        __classPrivateFieldSet(this, _Output_id, outputDef.id, "f");
        __classPrivateFieldSet(this, _Output_name, outputDef.name, "f");
        __classPrivateFieldSet(this, _Output_version, outputDef.version, "f");
        this.updateOutputDefinition(outputDef);
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (30)
    get bbmax() {
        return __classPrivateFieldGet(this, _Output_bbmax, "f");
    }
    get bbmin() {
        return __classPrivateFieldGet(this, _Output_bbmin, "f");
    }
    get chunks() {
        return __classPrivateFieldGet(this, _Output_chunks, "f");
    }
    get content() {
        return __classPrivateFieldGet(this, _Output_content, "f");
    }
    set content(value) {
        __classPrivateFieldSet(this, _Output_content, value, "f");
    }
    get delay() {
        return __classPrivateFieldGet(this, _Output_delay, "f");
    }
    get dependency() {
        return __classPrivateFieldGet(this, _Output_dependency, "f");
    }
    get displayname() {
        return __classPrivateFieldGet(this, _Output_displayname, "f");
    }
    set displayname(value) {
        __classPrivateFieldSet(this, _Output_displayname, value, "f");
    }
    get format() {
        return __classPrivateFieldGet(this, _Output_content, "f") ? __classPrivateFieldGet(this, _Output_content, "f").map(c => c.format) : [];
    }
    get freeze() {
        return __classPrivateFieldGet(this, _Output_sessionEngine, "f").outputsFreeze[__classPrivateFieldGet(this, _Output_id, "f")];
    }
    set freeze(value) {
        __classPrivateFieldGet(this, _Output_sessionEngine, "f").outputsFreeze[__classPrivateFieldGet(this, _Output_id, "f")] = value;
    }
    get hidden() {
        return __classPrivateFieldGet(this, _Output_hidden, "f");
    }
    set hidden(value) {
        __classPrivateFieldSet(this, _Output_hidden, value, "f");
    }
    get id() {
        return __classPrivateFieldGet(this, _Output_id, "f");
    }
    get material() {
        return __classPrivateFieldGet(this, _Output_material, "f");
    }
    get msg() {
        return __classPrivateFieldGet(this, _Output_msg, "f");
    }
    get name() {
        return __classPrivateFieldGet(this, _Output_name, "f");
    }
    get node() {
        return __classPrivateFieldGet(this, _Output_sessionEngine, "f").node.children.find(c => c.name === this.id);
    }
    get order() {
        return __classPrivateFieldGet(this, _Output_order, "f");
    }
    set order(value) {
        __classPrivateFieldSet(this, _Output_order, value, "f");
    }
    get status_collect() {
        return __classPrivateFieldGet(this, _Output_status_collect, "f");
    }
    get status_computation() {
        return __classPrivateFieldGet(this, _Output_status_computation, "f");
    }
    get tooltip() {
        return __classPrivateFieldGet(this, _Output_tooltip, "f");
    }
    set tooltip(value) {
        __classPrivateFieldSet(this, _Output_tooltip, value, "f");
    }
    get uid() {
        return __classPrivateFieldGet(this, _Output_uid, "f");
    }
    get updateCallback() {
        return __classPrivateFieldGet(this, _Output_updateCallback, "f");
    }
    set updateCallback(value) {
        __classPrivateFieldSet(this, _Output_updateCallback, value, "f");
    }
    get version() {
        return __classPrivateFieldGet(this, _Output_version, "f");
    }
    set version(value) {
        __classPrivateFieldSet(this, _Output_version, value, "f");
    }
    // #endregion Public Getters And Setters (30)
    // #region Public Methods (4)
    triggerUpdateCallback(newNode, oldNode) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _Output_updateCallback, "f"))
                yield Promise.resolve(__classPrivateFieldGet(this, _Output_updateCallback, "f").call(this, newNode, oldNode));
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateOutput(newNode, oldNode) {
        const outputDef = __classPrivateFieldGet(this, _Output_sessionEngine, "f").outputs[this.id];
        this.updateOutputDefinition(outputDef);
        // add chunk nodes
        if (this.chunks && newNode) {
            for (let i = 0; i < newNode.children.length; i++) {
                for (let j = 0; j < this.chunks.length; j++) {
                    this.chunks[j].node = newNode.children[i].children.find(child => child.name === this.chunks[j].id);
                }
            }
        }
    }
    updateOutputContent(outputContent, preventUpdate = false, waitForViewportUpdate = false) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _Output_sessionEngine, "f").outputs[this.id].content = outputContent;
            __classPrivateFieldGet(this, _Output_sessionEngine, "f").outputs[this.id].version = __classPrivateFieldGet(this, _Output_uuidGenerator, "f").create();
            if (!preventUpdate)
                yield __classPrivateFieldGet(this, _Output_sessionEngine, "f").updateOutputs(undefined, waitForViewportUpdate);
            return this.node;
        });
    }
    updateOutputDefinition(outputDef) {
        __classPrivateFieldSet(this, _Output_dependency, outputDef.dependency, "f");
        __classPrivateFieldSet(this, _Output_uid, outputDef.uid, "f");
        __classPrivateFieldSet(this, _Output_material, outputDef.material, "f");
        __classPrivateFieldSet(this, _Output_chunks, outputDef.chunks, "f");
        __classPrivateFieldSet(this, _Output_msg, outputDef.msg, "f");
        if (__classPrivateFieldGet(this, _Output_msg, "f") !== undefined)
            __classPrivateFieldGet(this, _Output_logger, "f").warn(`Output(${this.id}): ${__classPrivateFieldGet(this, _Output_msg, "f")}`);
        __classPrivateFieldSet(this, _Output_bbmin, outputDef.bbmin, "f");
        __classPrivateFieldSet(this, _Output_bbmax, outputDef.bbmax, "f");
        __classPrivateFieldSet(this, _Output_status_computation, outputDef.status_computation, "f");
        __classPrivateFieldSet(this, _Output_status_collect, outputDef.status_collect, "f");
        __classPrivateFieldSet(this, _Output_content, outputDef.content, "f");
        __classPrivateFieldSet(this, _Output_delay, outputDef.delay, "f");
        __classPrivateFieldSet(this, _Output_version, outputDef.version, "f");
        __classPrivateFieldSet(this, _Output_displayname, outputDef.displayname, "f");
        __classPrivateFieldSet(this, _Output_order, outputDef.order, "f");
        __classPrivateFieldSet(this, _Output_hidden, outputDef.hidden, "f");
    }
}
exports.Output = Output;
_Output_id = new WeakMap(), _Output_inputValidator = new WeakMap(), _Output_logger = new WeakMap(), _Output_name = new WeakMap(), _Output_sessionEngine = new WeakMap(), _Output_uuidGenerator = new WeakMap(), _Output_bbmax = new WeakMap(), _Output_bbmin = new WeakMap(), _Output_chunks = new WeakMap(), _Output_content = new WeakMap(), _Output_delay = new WeakMap(), _Output_dependency = new WeakMap(), _Output_displayname = new WeakMap(), _Output_hidden = new WeakMap(), _Output_material = new WeakMap(), _Output_msg = new WeakMap(), _Output_order = new WeakMap(), _Output_status_collect = new WeakMap(), _Output_status_computation = new WeakMap(), _Output_tooltip = new WeakMap(), _Output_uid = new WeakMap(), _Output_updateCallback = new WeakMap(), _Output_version = new WeakMap();
//# sourceMappingURL=Output.js.map